module.exports = __webpack_public_path__ + "static/media/icon-calendar.fc5886a5.svg";